export default "__VITE_ASSET__14e02a13__"